import React from "react";
import Section from "../../components/section/Section";
import KnowledgeBaseAccordion from "./components/knowledge-base-accordion/KnowledgeBaseAccordion";
import { useSelector } from "react-redux";

export const KNOWLEDGE_BASE = "knowledge-base";

const KnowledgeBase = () => {
  const { productName } = useSelector((state) => state.info.organization);
  return (
    <Section
      title="Knowledge Base"
      subtitle={`Add relevant business details and let your ${productName} answer your customers' most frequent questions.`}
      content={<KnowledgeBaseAccordion />}
    />
  );
};

export default KnowledgeBase;
